import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ExpandLess(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
    </SvgIcon>
  )
}
